import React from "react";
import ReactDOM from "react-dom/client";
import ProjectList from "./components/ProjectList";
import Certificate from "./components/Certificate";
import Profile from "./components/Profile";
import Portfolio from "./components/Portfolio";

const App = () => {
	return (
		<div>
			<Portfolio />
			{/* <Profile />
			<span className="inline-block mx-10 my-4 text-4xl">Projects</span>
			<ProjectList />
			<span className="inline-block mx-10 my-4 text-4xl">Certifications</span>
			<Certificate /> */}
		</div>
	);
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);
